import React, { useEffect, useState, useRef, useCallback } from "react";
import Typography from "@mui/material/Typography";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import reparaturStore from "../../../Stores/ReparaturStore";
import ReparaturConstants from "../../../Constants/ReparaturContstants";
import ReparaturActions from "../../../Actions/ReparaturActions";
import { useAMGSelectedContext } from "../../../Context/GlobalContext";
import AddMaintenance from "../../Equipment-Details/AddMaintenance";
import { Button } from "@mui/material";

function Maintenance(props) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();
  const location = useLocation();
  const { anlageid, isFunctionCall, handleTourGuid } = props;

  const [data, setData] = useState([]);

  const [refresh, setRefresh] = useState(null);
  const [openAddMaintenance, setOpenAddMaintenance] = useState(false);
  const isMountedRef = useRef(null);
  const columns = [
    {
      field: "bezeichnung",
      headerName: localization.title,
      hideable: false,
      flex: 1,
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   hideable: false,
    //   getActions: (params) => [...getAction(params, localization)],
    // },

    {
      field: "eintragDatumDisplay",
      headerName: localization.date,
      hideable: false,
      flex: 1,
    },
    {
      field: "user",
      headerName: localization.createdBy,
      hideable: false,
      flex: 1,
    },
    {
      field: "auftragsNr",
      headerName: localization.auftragsNr,
      hideable: false,
      flex: 1,
    },
  ];

  const fetchData = useCallback(() => {
    setGlobalSpinner(true);
    var _anlageid = sessionStorage.getItem("eqId") || anlageid;
    if ((_anlageid !== null && _anlageid !== undefined) || refresh) {
      ReparaturActions.getReparaturen(_anlageid);
    }
  }, [refresh]);
  // fetch data end ----------

  useEffect(() => {
    isMountedRef.current = true;

    fetchData();

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    function getRepairListSuccess() {
      var _details = reparaturStore.getResult();
      if (_details) {
        let tempArr = _details.map((item, index) => {
          item["id"] = index;
          return item;
        });
        setData(tempArr);
      }

      handleTourGuid(5);
      setGlobalSpinner(false);
    }

    function getRepairListError() {
      var _details = reparaturStore.getResult();
      setData(_details);
      setGlobalSpinner(false);
    }

    reparaturStore.addChangeListener(
      ReparaturConstants.GET_REPARTURLIST_SUCCES,
      getRepairListSuccess,
    );

    reparaturStore.addChangeListener(
      ReparaturConstants.GET_REPARTURLIST_FAILURE,
      getRepairListError,
    );

    return () => {
      reparaturStore.removeChangeListener(
        ReparaturConstants.GET_REPARTURLIST_SUCCES,
        getRepairListSuccess,
      );

      reparaturStore.removeChangeListener(
        ReparaturConstants.GET_REPARTURLIST_FAILURE,
        getRepairListError,
      );
    };
  }, []);

  const handleAddMaintenanceCallback = () => {
    setOpenAddMaintenance(false);
    setRefresh(true);
  };

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <div className="">
            <Typography gutterBottom variant="h4" component="div">
              {localization.maintenanceSchedule}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {localization.upcomingAndPastMaintenance}
            </Typography>
          </div>

          <div>
            <Button
              variant="contained"
              className="containedBtnCls"
              sx={{ textTransform: "none" }}
              startIcon={<AddOutlinedIcon />}
              size="large"
              onClick={() => {
                setOpenAddMaintenance(true);
              }}
            >
              {/* <AddOutlinedIcon sx={{ fontSize: 18 }} className="mr-2" /> */}
              {localization.addMaintenance}
            </Button>
          </div>
        </div>
        <div className="w-100">
          <CustomDataGrid
            columns={columns}
            rows={data}
            operations={{}}
            onAdd={{}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[]}
            showCheckBox={false}
            gridTableHeight={"dataGridLarge"}
          />
        </div>
      </div>
      {openAddMaintenance && (
        <AddMaintenance
          anlageid={anlageid}
          isOpen={openAddMaintenance}
          setOpenAddMaintenance={setOpenAddMaintenance}
          addMaintenanceCallBack={handleAddMaintenanceCallback}
        />
      )}
    </>
  );
}
export default Maintenance;
